import { isString } from 'lodash-es';

export const checkVinValidity = (vin: string): boolean => {
  const isValidVin = vin && isString(vin) && vin.length === 17;
  return isValidVin;
};
